<template>
  <div>
    <v-row>
      <v-col cols="4">
        <v-card tile min-height="650px">
          <core-form ref="form" :submit="consultaBereau">
            <v-row id="consulta-tabs">
              <v-tabs v-model="tab" hide-slider class="pt-3" @change="buscaContador">
                <v-tab
                  v-for="item in items"
                  :key="item.id"
                  :disabled="item.ativado === false"
                  @click="changeBureau"
                >
                  {{ item.bureau }}
                  <v-icon small class="ml-2" v-show="item.ativado === false"
                    >fa-solid fa-lock</v-icon
                  >
                </v-tab>
              </v-tabs>
              <ContadorBureau ref="contador" />
            <v-col cols="12">
              <v-icon color="primary">ph-funnel</v-icon>
                <span class="pl-1">Filtro</span>
              </v-col>
              <v-col cols="12" class="pb-0">
                <input-month
                  :required="tab === 0"
                  :max="dtMax"
                  label="Data de Início"
                  v-model="model.DtInicio"
                  :show-current="dtMax"
                  @input="changeDtInicio"
                  :disabled="disableInputDate"
                  :readonly="disableInputDate"
                />
                <input-month
                  :required="tab === 0"
                  :max="dtMaxFim"
                  label="Data de Fim"
                  v-model="model.DtFim"
                  :show-current="model.DtInicio"
                  :min="model.DtInicio"
                  :readonly="!model.DtInicio || disableInputDate"
                  :disabled="disableInputDate"
                />
              </v-col>
              <v-col cols="12" class="mt-0">
                <input-documento
                  v-if="showDocumentoFederal"
                  required
                  label="CPF / CNPJ"
                  v-model="model.Documento"
                />
                <input-email v-if="showEmail" required label="E-mail" v-model="model.Email"/>
              </v-col>
            </v-row>
            <v-tabs-items v-model="tab">
              <v-tab-item v-for="item in items" :key="item.id"></v-tab-item>
            </v-tabs-items>
            <v-card-actions>
              <v-row class="d-flex justify-center">
                <v-btn color="primary" type="submit" data-cy="consultar">Consultar</v-btn>
              </v-row>
            </v-card-actions>
          </core-form>
        </v-card>
      </v-col>
      <v-col cols="8">
        <v-card elevation="1" outlined tile min-width="90vh" min-height="650px">
          <component v-if="showConsulta" :is="consultaAtual.componente" :ref="consultaAtual.ref" :value="model" eager @error="() => showConsulta = false"/>
          <div v-else class="d-flex align-center" style="height: 70vh">
            <v-row>
              <v-col cols="12" class="d-flex justify-center">
                <v-img
                  slot="image"
                  src="assets/imgs/pasta-vazia.svg"
                  max-width="116"
                  max-height="116"
                />
              </v-col>
              <v-col cols="12" class="d-flex justify-center">
                <span>Aguardando consulta</span>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ScrBacen from './bureaus/scrBacen/ScrBacen.vue'
import Serasa from './bureaus/serasa/Serasa.vue'
import DataBusca from './bureaus/dataBusca/DataBusca.vue'
import SpcBrasil from './bureaus/spcBrasil/SpcBrasil.vue'
import EmailAge from './bureaus/emailAge/EmailAge.vue';
import AllCheck from './bureaus/allCheck/AllCheck.vue';
import ContadorBureau from '../../../components/ContadorBureau.vue'

export default {
  components: {
    ContadorBureau,
  },
  data () {
    return {
      showConsulta: false,
      tab: null,
      model: {
        ResumoDoCliente: {},
        ResumoDoClienteTraduzido: {},
        ResumoModalidade: [],
      },
      items: this.$param.EST_BUREAUS,
      consultaAtual: {
        componente: ScrBacen,
        ref: 'SCRBacen'
      }
    };
  },
  computed: {
    dtMax () {
      return this.$api.UI.Format.Date(
        this.$api.UI.Date.AddDay(new Date(), -45),
        'yyyy-MM'
      );
    },
    dtMaxFim () {
      if (this.model.DtInicio) {
        let date = this.model.DtInicio + '-01';
        date = this.$api.UI.Date.AddMonth(date, 11);

        if (date > this.$api.UI.Date.AddDay(new Date(), -45)) {
          return this.dtMax;
        } else {
          return this.$api.UI.Format.Date(date, 'yyyy-MM');
        }
      }
      return null;
    },
    disableInputDate () {
      return this.tab !== 0
    },
    showEmail () {
      const bureaus = [8]
      return bureaus.includes(this.tab);
    },
    showDocumentoFederal () {
      const bureaus = [0, 1, 2, 3, 6];
      return bureaus.includes(this.tab)
    }
  },
  methods: {
    changeDtInicio (value) {
      const th = this;
      th.$set(th.model, 'DtFim', value);
    },
    consultaBereau () {
      const th = this;
      th.$refs.form.validate(function () {
        switch (th.items[th.tab].bureau) {
          case 'SCR BACEN':
            th.showConsulta = true;
            th.$set(th.consultaAtual, 'componente', ScrBacen)
            th.$set(th.consultaAtual, 'ref', 'SCRBacen')
            setTimeout(() => {
              th.$refs.SCRBacen.consultaSCR(th.model.DtInicio, th.model.DtFim);
            }, 10);
            break
          case 'SERASA':
            th.showConsulta = true;
            th.$set(th.consultaAtual, 'componente', Serasa)
            th.$set(th.consultaAtual, 'ref', 'Serasa')
            setTimeout(() => {
              th.$refs.Serasa.ConsultaSerasa(th.model.Documento);
            }, 10);
            break
          case 'DATA BUSCA':
            th.showConsulta = true;
            th.$set(th.consultaAtual, 'componente', DataBusca)
            th.$set(th.consultaAtual, 'ref', 'DataBusca')
            setTimeout(() => {
              th.$refs.DataBusca.ConsultaDataBusca(th.model.Documento);
            }, 10);
            break
          case 'SPC BRASIL':
            th.showConsulta = true;
            th.$set(th.consultaAtual, 'componente', SpcBrasil)
            th.$set(th.consultaAtual, 'ref', 'SPCBrasil')
            setTimeout(() => {
              th.$refs.SPCBrasil.ConsultaSPC(th.model.Documento);
            }, 10);
            break
          case 'EMAILAGE':
            th.showConsulta = true;
            th.$set(th.consultaAtual, 'componente', EmailAge)
            th.$set(th.consultaAtual, 'ref', 'EmailAge')
            setTimeout(() => {
              th.$refs.EmailAge.ConsultaEmailAge(th.model.Email);
            }, 10);
            break
          case 'ALL CHECK':
            th.showConsulta = true;
            th.$set(th.consultaAtual, 'componente', AllCheck)
            th.$set(th.consultaAtual, 'ref', 'AllCheck')
            setTimeout(() => {
              th.$refs.AllCheck.ConsultaAllCheck(th.model.Documento);
            }, 10);
            break
        }
      })
    },
    changeBureau () {
      const th = this
      th.showConsulta = false
      if (th.tab === 0) {
        th.$set(th.model, 'DtInicio', null)
        th.$set(th.model, 'DtFim', null)
      }
    },
    buscaContador () {
      const th = this;
      th.$nextTick(() => th.$refs.contador.buscaContador(th.items[th.tab].bureau))
    }
  }
};
</script>

<style>
#consulta-tabs .v-tabs-bar__content {
  flex-wrap: wrap;
  width: 100%;
}
#consulta-tabs div.v-tabs-bar {
  height: auto;
}
#consulta-tabs div.v-tab {
  line-height: 3rem; /* or use padding instead */
}
</style>
